import {path, alias} from '@acng/frontend-voyager';
import {guestRoute} from 'acng/userPool/config/routes';

guestRoute.create(
  path('/alternativeProducts'), //
  alias('alternativeProducts')
);
